//TODO: Moving this out of SavedQuotesGrid.tsx as it is being used in numreous places. This can be better, but minimally it should be in a shared location.
export const agGridCellStyle = {
  padding: '10px',
  'word-break': 'break-word',
  'white-space': 'normal',
  'line-height': '1.6 ',
  'align-items': 'center !important',
};
